/**
 * /app/$tenantSlug/hiring/jobs — old Jobs list. It was the same page as
 * Manage → Hiring → Jobs (/hiring), so it redirects there, keeping any
 * query string.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/hiring/jobs",
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/app/$tenantSlug/hiring",
      params: { tenantSlug: params.tenantSlug },
      search: search as never,
      replace: true,
    });
  },
});
